import api from "../../../../services/api";

const getSignature = () => localStorage.getItem("signature");

const post = async (path: string, body: Record<string, any>) => {
  const response = await api.post(path, {
    signature: getSignature(),
    ...body,
  });
  return response.data?.data;
};

export const addWatcher = async (
  companyId: string,
  companyType: string,
  issueId: number,
  userId?: number
) =>
  post("projectService/watcher/addWatcher", {
    company_id: companyId,
    company_type: companyType,
    issue_id: issueId,
    ...(userId ? { user_id: userId } : {}),
  });

export const removeWatcher = async (
  companyId: string,
  companyType: string,
  issueId: number,
  userId?: number
) =>
  post("projectService/watcher/removeWatcher", {
    company_id: companyId,
    company_type: companyType,
    issue_id: issueId,
    ...(userId ? { user_id: userId } : {}),
  });

export const listForIssue = async (
  companyId: string,
  companyType: string,
  issueId: number
) =>
  post("projectService/watcher/listForIssue", {
    company_id: companyId,
    company_type: companyType,
    issue_id: issueId,
  });

export const listMyWatched = async (
  companyId: string,
  companyType: string,
  page: number = 1,
  limit: number = 50
) =>
  post("projectService/watcher/listMyWatched", {
    company_id: companyId,
    company_type: companyType,
    page,
    limit,
  });
